/**
 * Iniciales para el avatar: las primeras letras de las dos primeras
 * palabras del nombre completo, en mayúsculas. Ej. "Juan García" → "JG".
 * Centraliza la lógica que antes estaba duplicada en cada pantalla.
 */
export function getInitials(fullName: string): string {
  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() ?? '')
    .join('');
}
